module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900-376c1f97f6553dea1ca9b3f9081889bd.svg";